import { render } from "./CreateBlogPost.vue?vue&type=template&id=48d5c6cd&scoped=true"
import script from "./CreateBlogPost.vue?vue&type=script&lang=js"
export * from "./CreateBlogPost.vue?vue&type=script&lang=js"

import "./CreateBlogPost.vue?vue&type=style&index=0&id=48d5c6cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d5c6cd"]])

export default __exports__